import {VIEW_MY} from './view_my'

var VIEW_CONFIG = {
    // 底部导航栏设置
    bottomMenuBar: {
        showCollate: true,
        showRecord: true,
        showDiscuss: true,
        showFamousPedia: true,
        showHuangLi: true,
        showMy: true
    }
}

VIEW_CONFIG = Object.assign(VIEW_CONFIG, VIEW_MY)

export {
    VIEW_CONFIG
}